import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette, hexToRgba } from '../../../../styles/colors';
import { BEZIER_CURVES, ANIMATION_LENGTH } from '../../../../utils/animations';

const MENU_HAMBURGUER_ANIMATION_TRANSITION = `${ANIMATION_LENGTH._1000MS}
  ${BEZIER_CURVES.FLUID}`;

export const phoneNumberHolder = css({
  '.desktop-view-phone-number': {
    alignItems: 'center',
    display: 'none',

    '.cust-call-no': {
      paddingRight: '10px',
    },

    '.cust-call-us': {
      color: '#393939',
      fontWeight: 500,
      margin: '0 16px 0 0px',
    },

    [MediaQueries.sm]: {
      display: 'none',
    },
  },

  '.mobile-view-phone-number': {
    display: 'flex',
    [MediaQueries.sm]: {
      display: 'block',
    },
  },
});
export const phoneNumberSticky = css({
  '.desktop-view-phone-number': {
    alignItems: 'center',
    display: 'flex',
    paddingRight: '15px',
    paddingTop: '5px',
    [MediaQueries.lg]: {
      display: 'none',
    },
    [MediaQueries.md]: {
      display: 'none',
    },

    '.cust-call-no': {
      paddingRight: '0px',
      i: {
        padding: '20px 10px',
      },
    },

    '.cust-call-us': {
      color: '#393939',
      fontWeight: 500,
      margin: '0 16px 0 0px',
    },

    [MediaQueries.sm]: {
      display: 'none',
    },
  },

  '.mobile-view-phone-number': {
    display: 'none',
    [MediaQueries.sm]: {
      display: 'block',
    },
    [MediaQueries.md]: {
      display: 'block',
    },
    [MediaQueries.lg]: {
      display: 'block',
    },
  },
});

export const hideElement = css({
  display: 'none',
});
export const buttonReset = css({
  background: 'none',
  border: 'none',
  padding: 0,
  textDecoration: 'none',
  '.searchclose_ic': {
    marginRight: '0px !important',
  },

  '.icon-closer': {
    marginRight: '15px',
    position: 'relative',

    [MediaQueries.sm]: {
      padding: '20px 0',
      display: 'block',
    },
  },
});

export const listCss = css({
  display: 'flex',
});

export const menuSizeCss = css({
  fontSize: 9,
  display: 'block',
  position: 'relative',
  zIndex: 1,
  '-webkit-font-smoothing': 'none',
});

export const waysToWorkCss = css(typography.effra16, {
  marginLeft: 0,
  pointerEvents: 'none',
  transition: MENU_HAMBURGUER_ANIMATION_TRANSITION,
});

export const waysToWorkButtonCss = css({
  position: 'absolute',
  left: -10,
});

export const regusLogoCss = css({
  fontSize: 30,
  pointerEvents: 'none',
  [MediaQueries.mdAndUp]: {
    fontSize: 38,
  },
});

export const phoneButtonCss = css({
  [MediaQueries.mdAndUp]: {
    marginTop: 5,
  },
});

export const phoneSizeCss = css({
  fontSize: 15,
  pointerEvents: 'none',
  position: 'relative',
  zIndex: 2,
  [MediaQueries.lgAndUp]: {
    fontSize: 16,
  },
});

export const searchButtonCss = css({
  [MediaQueries.lg]: {
    marginRight: 9,
  },
  [MediaQueries.xl]: {
    marginRight: 16,
  },
});

export const searchLocationTextCss = css(typography.effra16, {
  fontWeight: fontWeights.regular,
  color: colorsPalette.black,
  pointerEvents: 'none',
  transform: 'translateX(-12px)',
  transition: MENU_HAMBURGUER_ANIMATION_TRANSITION,
});

export const activeSearchTextCss = css({
  color: colorsPalette.white,
  transform: 'translateX(10px)',
  transition: 'none',
});

export const searchSizeCss = css({
  marginTop: 2,
  fontSize: 19,
  pointerEvents: 'none',
  position: 'relative',
  zIndex: 2,
  padding: '15px 5px',
  [MediaQueries.mdAndUp]: {
    fontSize: 20,
    padding: 20,
  },
  [MediaQueries.lgAndUp]: {
    fontSize: 22,
  },
});

export const profileSizeCss = css({
  fontSize: 16,
  position: 'relative',
  zIndex: 2,
  [MediaQueries.lgAndUp]: {
    fontSize: 16,
  },
});

export const profileButtonCss = css({
  position: 'relative',

  [MediaQueries.sm]: {
    i: {
      padding: '20px 8px',
    },
  },
});

export const iconCloserSizeCss = css({
  fontSize: 13,
  [MediaQueries.lgAndUp]: {
    fontSize: 16,
  },
});

export const accountbtnCss = css({
  position: 'relative',
  top: '1px',
});

export const loginCss = css(typography.effra16, {
  marginLeft: -6,
  pointerEvents: 'none',
  transition: MENU_HAMBURGUER_ANIMATION_TRANSITION,
  position: '',
});

export const verticalLineCss = css({
  width: 1,
  height: '100%',
  backgroundColor: colorsPalette.grey10,
  [MediaQueries.md]: {
    margin: '0 12px',
  },
  [MediaQueries.lg]: {
    margin: '0 19px',
  },
  [MediaQueries.xl]: {
    margin: '0 28px',
  },
});

export const verticalLineDarkModeCss = css({
  backgroundColor: colorsPalette.grey90,
});

export const flexWrapperCss = css({
  display: 'flex !important',
  alignItems: 'center',
  color: 'inherit',
  cursor: 'pointer',
  marginTop: '0px !important',
});

export const regusLogoWrapperCss = css({
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',

  [MediaQueries.md]: {
    display: 'flex',
  },
});

export const hoverStyleCss = isOpenModal => ({
  padding: 20,
  '&:hover': {
    background: isOpenModal
      ? hexToRgba(colorsPalette.grey80, 0.1)
      : colorsPalette.brown10,
  },
});

export const hoverStyleHamburguerCss = {
  borderRadius: '50%',
  padding: '23px 14px',
  transition: MENU_HAMBURGUER_ANIMATION_TRANSITION,
  transformOrigin: 'center',
};

export const hoverStyleIconCss = {
  borderRadius: '50%',
  padding: 20,
  transition: MENU_HAMBURGUER_ANIMATION_TRANSITION,
  transformOrigin: 'center',
  display: 'block',
};

export const circleHoverCss = css({
  height: '100%',
  width: '100%',
  position: 'absolute',
  transform: 'scale(0)',
  transition: MENU_HAMBURGUER_ANIMATION_TRANSITION,
  top: 0,
  left: 0,
  borderRadius: '50%',
  zIndex: 0,
});

const animatedCircleAndText = isOpenModal => ({
  '.translate-text': {
    transform: 'translateX(10px)',
  },
  '.circle-hover': {
    transform: 'scale(1)',
    background: isOpenModal
      ? hexToRgba(colorsPalette.grey80, 0.1)
      : colorsPalette.brown10,
  },
});

export const containerAnimationCss = isOpenModal =>
  css({
    '&:hover': {
      ...animatedCircleAndText(isOpenModal),
    },
  });

export const animationContainerCss = css({
  pointerEvents: 'none',
  position: 'relative',
});

export const flexContainer = css({
  display: 'flex',
});

export const alignRight = css({
  width: '100% !important',
  display: 'flex',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  position: 'relative',
  right: '-10px',
});

export const activeCss = css({
  background: hexToRgba(colorsPalette.grey80, 0.1),
});

export const activeWaysToWorkCss = isOpenModal =>
  css({ ...animatedCircleAndText(isOpenModal) });
